import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { PURPOSE_SOURCE_VALUES } from '@sravni/creditselection-customer-utils/lib/utils/customers';

import {
  ANY_AUTO_BRAND_DICTIONARY_SELECT_OPTION,
  ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION,
} from 'constants/dictionaries';

import { isSatisfyOption } from 'shared/lib';

import type { TCreditFormCommonFields } from 'entities/creditForm';

export const useIsShowAutoFields = () => {
  const { watch } = useFormContext<TCreditFormCommonFields>();

  const purpose = watch('purpose.value');
  const brand = watch('autoBrand.value');
  const model = watch('autoModel.value');

  const isShowAutoFields = isSatisfyOption([PURPOSE_SOURCE_VALUES.NEW_CAR, PURPOSE_SOURCE_VALUES.USED_CAR], purpose);
  const isAnyAutoBrandSelected = brand === ANY_AUTO_BRAND_DICTIONARY_SELECT_OPTION.value;
  const isAnyAutoModelSelected = model === ANY_AUTO_MODEL_DICTIONARY_SELECT_OPTION.value;

  return {
    isShowAutoFields,
    isShowAutoModelField: isShowAutoFields && !!brand && !isAnyAutoBrandSelected,
    isShowAutoYearField: isShowAutoFields && !!model && !isAnyAutoModelSelected,
  };
};
